
import StoredSet from '@/interfaces/stored-set';
import { plantImageUrlForStoredType } from '@/lib/plant-images';
import { Component, Prop, Vue } from 'vue-property-decorator';

const GENE_SETS_KEY = 'PREVIOUS_GENE_SETS';
const MAX_STORED_SETS = 200;

@Component
export default class PreviousGenes extends Vue {
  @Prop({ type: String }) readonly selectedPlantTypeName: string;
  storedSets: StoredSet[] = [];

  get storedSetsDetailed() {
    return this.storedSets.map((set) => {
      const imgName = set.selectedPlantTypeName || 'mixed-berry';
      return {
        ...set,
        saplingsCount: set.genes.split('\n').length,
        dateString: new Date(set.timestamp).toLocaleString(),
        imgName,
        imageUrl: plantImageUrlForStoredType(set.selectedPlantTypeName)
      };
    });
  }

  constructor() {
    super();
    window.addEventListener('storage', () => {
      this.loadStoredSets();
    });
  }

  mounted() {
    this.loadStoredSets();
  }

  loadStoredSets() {
    const storedSetsJSON = localStorage.getItem(GENE_SETS_KEY);
    if (storedSetsJSON) {
      this.storedSets = JSON.parse(storedSetsJSON);
    }
  }

  storeSets() {
    localStorage.setItem(GENE_SETS_KEY, JSON.stringify(this.storedSets));
  }

  addNewSet(genes: string) {
    this.loadStoredSets();
    if (
      !this.storedSets.find((set) => set.genes === genes && set.selectedPlantTypeName === this.selectedPlantTypeName)
    ) {
      const newSet: StoredSet = {
        timestamp: Date.now(),
        selectedPlantTypeName: this.selectedPlantTypeName,
        genes
      };
      this.storedSets = [newSet, ...this.storedSets];
      if (this.storedSets.length > MAX_STORED_SETS) {
        this.storedSets.pop();
      }
      this.storeSets();
      return true;
    }
    return false;
  }

  handleSetSelect(index: number) {
    this.$emit('genes-selected', this.storedSets[index]);
  }

  handleRemoveSetClick(event: Event, index: number) {
    event.stopPropagation();
    this.storedSets.splice(index, 1);
    this.storeSets();
  }
}
